/* eslint-disable react/no-array-index-key */
import { getItemLocalStorage } from 'utils/localStorage';
import { Button, Result } from 'antd';
import ControllerHeader from 'pages/Print/components/ControllerHeader';
import HelpModal from 'modules/Print/QuestionModules/HelpModal';
import { onPrintPage } from 'pages/Print/functions/PrintFunctions';
import AnswersAndFiles from './AnswersAndFiles';
import { fakeData } from './test_data';
import RenderQuestionType from './RenderQuestionType';

const ViewExamPrint = () => {
  document.title = 'In đề thi';

  const { exam } = getItemLocalStorage();

  if (!exam?.id) {
    return <Result status='404' title='Không tìm thấy dữ liệu' subTitle='Vui lòng thử lại chức năng in!' />;
  }
  const { id, quizTitle, jsonData, totalQuestion, duration } = exam ?? fakeData;
  const questions = jsonData?.questions ?? [];

  return (
    <div>
      <ControllerHeader>
        <Button type='primary' onClick={() => onPrintPage()}>
          In (có đáp án)
        </Button>
        <Button type='primary' onClick={() => onPrintPage(['answer-and-file'])}>
          In (không có đáp án)
        </Button>
        <HelpModal />
      </ControllerHeader>
      <div style={{ fontSize: 35, fontWeight: 600, textAlign: 'center', margin: '40px 0px 60px 0px' }}>{quizTitle}</div>
      {questions?.map((question: any, index: number) => (
        <div className='tw-mb-4' key={index}>
          <RenderQuestionType key={index} questionIndex={index} questionData={question} printMode />
        </div>
      ))}
      <div className='answer-and-file'>
        <AnswersAndFiles questions={questions} />
      </div>
    </div>
  );
};

export default ViewExamPrint;
